// extracted by mini-css-extract-plugin
export default {"container":"vyapari-bill-print_container__v3W5i","heading":"vyapari-bill-print_heading__IUl8K","constants":"vyapari-bill-print_constants__y3GgJ"};